import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import {darkenedBg, sections} from "../../assets/settings";

function SectionTop(props) {
    const {group, children, downhill} = props;

    const section = sections.find((s) => s.key === group);
    if (!section) throw `No section with this group key: ${group}`;
    const style = {
        backgroundImage: `url(img/${group}/${group}_background.jpg)`
    };
    let className = 'SectionTop';
    if (downhill) {
        className += ' downhill';
    }
    return (
        <div className={className} style={style}>
            <h1 id={group + '_header'}>{section.title}</h1>
            <div className={'banner-box'} style={{backgroundColor: darkenedBg(section.color)}}>
                {children}
            </div>
        </div>
    );
}

export default observer(SectionTop);
